import { CustomFieldDataType } from "@portal/types/entities/custom-field";
import {
  CellRenderProps,
  defaultCellComponents,
  GrowTypography,
} from "@sinecycle/growcomponents";

interface CustomColumnProps {
  value: string;
  type: CustomFieldDataType;
}

function CFCell<T>(props: CellRenderProps<T, CustomColumnProps>) {
  const customField = props.value;

  switch (customField.type) {
    case 'SINGLE_SELECT':
    case "NUMBER":
    case "BOOLEAN":
    case "DECIMAL":
    case "TEXT":
      return defaultCellComponents.textCell({
        ...props,
        value: customField.value,
        textCellProps: {
          ellipsis: {
            tooltip: {
              placement: "top",
            },
          },
        },
      });
    case "DATE":
    case "DATETIME":
      return defaultCellComponents.dateCell({
        ...props,
        value: customField.value,
      });

    case "URL":
      return (
        <GrowTypography.Link
          href={customField.value}
          target="_blank"
          ellipsis={{
            tooltip: {
              title: customField.value,
              placement: "top",
            },
          }}
        >
          {customField.value}
        </GrowTypography.Link>
      );

    default:
      return defaultCellComponents.textCell({
        ...props,
        value: customField.value,
        textCellProps: {
          ellipsis: {
            tooltip: {
              placement: "top",
            },
          },
        },
      });
  }
}

export { CFCell };
